import { reactive, toRefs } from '@vue/composition-api';
import { useTimeoutFn } from '@vueuse/core';

import { MNOGORU_COUPON_LENGTH } from '@/utils/constants/globalConst';

import useHttpClient from '@/compositions/useHttpClient';

const useMnogoRuCard = () => {
  const { mnogoRu } = useHttpClient();

  const localState = reactive({
    cardValue: '',
    isError: false,
    isSuccess: false,
    isLoadingState: false,
    errorText: '',
    successText: '',
    isApplied: false,
  });

  const { start, stop } = useTimeoutFn(() => {
    localState.successText = '';
  }, 3000);

  const resetFlags = () => {
    localState.isError = false;
    localState.isSuccess = false;
    localState.isLoadingState = false;
  };

  const resetErrorText = () => {
    localState.errorText = '';
  };

  const resetSuccessText = () => {
    stop();
    localState.successText = '';
  };

  const fetchAppliedMnogoRuCard = () => new Promise((resolve) => {
    localState.isLoadingState = true;

    mnogoRu.fetchAppliedMnogoRuCard()
      .then((card) => {
        localState.cardValue = card;
        localState.isSuccess = !!card.length;
        localState.isApplied = !!card.length;
        localState.isError = false;
        resolve(card);
      })
      .catch((error) => {
        localState.errorText = error.message;
        localState.isError = true;
        localState.isSuccess = false;
      })
      .finally(() => {
        localState.isLoadingState = false;
      });
  });

  const applyMnogoRuCard = () => new Promise((resolve) => {
    resetFlags();
    resetErrorText();
    localState.isLoadingState = true;

    mnogoRu.applyMnogoRuCard(localState.cardValue)
      .then((card) => {
        localState.cardValue = card;
        localState.isSuccess = !!card.length;
        localState.isError = false;
        localState.successText = 'Карта сохранена';
        start();
        resolve(card);
      })
      .catch((error) => {
        localState.errorText = error.message;
        localState.isError = true;
        localState.isSuccess = false;
      })
      .finally(() => {
        localState.isLoadingState = false;
      });
  });

  const removeAppliedMnogoRuCard = () => new Promise((resolve) => {
    resetFlags();
    resetErrorText();
    resetSuccessText();
    localState.isLoadingState = true;

    mnogoRu.removeAppliedMnogoRuCard(localState.cardValue)
      .then((data) => {
        localState.isSuccess = false;
        localState.isError = false;
        localState.errorText = '';
        localState.cardValue = '';
        resolve(data);
      })
      .catch((error) => {
        localState.errorText = error.message;
        localState.isError = true;
        localState.isSuccess = false;
      })
      .finally(() => {
        localState.isLoadingState = false;
      });
  });

  const filterInput = (event) => {
    if (event.target.value.length >= MNOGORU_COUPON_LENGTH) {
      return event.preventDefault();
    }

    const regex = /[0-9]/g;
    if (new RegExp(regex).test(event.key)) {
      return true;
    }

    return event.preventDefault();
  };

  return {
    ...toRefs(localState),
    fetchAppliedMnogoRuCard,
    applyMnogoRuCard,
    removeAppliedMnogoRuCard,
    filterInput,
  };
};

export default useMnogoRuCard;
